import {DeleteRecordsConfirmationButton} from '@flexinet/ui-components';

import {useBillableUnitsSelection} from '../hooks/useBillableUnitsSelection';
import {useDeleteBillableUnitsMutation} from '../hooks/useBillableUnitsQuery';

export const DeleteRecordButton = () => {
    const {selectedRecords, clearSelection} = useBillableUnitsSelection();
    const mutation = useDeleteBillableUnitsMutation();

    const handleConfirm = () => {
        mutation.mutate(selectedRecords.map(record => record.id), {
            onSuccess: () => clearSelection(),
        });
    };

    return (
        <DeleteRecordsConfirmationButton
            disabled={selectedRecords.length === 0 || mutation.isPending}
            recordIdsLength={selectedRecords.length}
            handleConfirm={handleConfirm}
        />
    );
};
